import update from 'react-addons-update';
import { API_ANNOUNCEMENTS_ARCHIVE, API_DISMISS_ANNOUNCEMENTS, API_FETCH_ANNOUNCEMENTS_SUMMARY, API_MARK_ANNOUNCEMENTS_VIEWED } from '../actionTypes';
import { loadAnnouncementDismissals } from './announcements.storage';

const initialAnnouncementsState: AnnouncementsStoreState = {
    ShowRedDot: false,
    Announcements: [],
    announcementsArchive: {}
};

// eslint-disable-next-line
const reducer = (state: AnnouncementsStoreState = initialAnnouncementsState, incomingAction: AnnouncementsAction) => {
    const action = incomingAction;
    switch (action.type) {
        case API_FETCH_ANNOUNCEMENTS_SUMMARY: {
            const actionObj = action as FetchAnnouncementsSummaryAction;
            const dismissedIds = actionObj.isLoggedIn ? [] : loadAnnouncementDismissals();
            // Filter out announcements that were dismissed in sessionStorage
            const announcements = Array.isArray(actionObj.response.Announcements) ? actionObj.response.Announcements : [];
            const filteredAnnouncements = announcements.filter(
                item => !dismissedIds.includes(item.KeyMarketplaceAnnouncements)
            );

            const backendUnread = typeof (actionObj.response as any).unread === 'boolean'
                ? (actionObj.response as any).unread
                : Boolean(actionObj.response.ShowRedDot);
            const nextShowRedDot = actionObj.isLoggedIn ? backendUnread : filteredAnnouncements.length > 0;

            return update(state, {
                ShowRedDot: { $set: nextShowRedDot },
                Announcements: { $set: filteredAnnouncements }
            });
        }
        case API_DISMISS_ANNOUNCEMENTS: {
            const actionObj = action as DismissAnnouncementsAction;
            const remainingAnnouncements = state.Announcements.filter(item => !actionObj.announcementIds.includes(item.KeyMarketplaceAnnouncements));
            return update(state, {
                Announcements: { $set: remainingAnnouncements }
            });
        }
        case API_ANNOUNCEMENTS_ARCHIVE: {
            const actionObj = action as FetchAnnouncementsArchiveAction;
            return update(state, { announcementsArchive: { $set: actionObj.announcementsArchive } });
        }
        case API_MARK_ANNOUNCEMENTS_VIEWED:
            return update(state, { ShowRedDot: { $set: false } });
        default:
            return state || initialAnnouncementsState;
    }
};

export { reducer, initialAnnouncementsState };
